
document.addEventListener('DOMContentLoaded', function () {
  // HIER die echte Shopify-Varianten-ID eintragen
  const FEE_VARIANT_ID = 55641892028743;

  // Nur auf der Warenkorbseite ausführen
  if (!document.getElementById('main-cart-footer')) return;

  const root = window.Shopify?.routes?.root || '/';
  let processing = false;
  let ready = false;

  function setCheckoutDisabled(disabled) {
    const button = document.getElementById('checkout');
    if (button) button.disabled = disabled;
  }

  function showError(message) {
    const box = document.getElementById('service-fee-error');
    if (!box) return;

    box.textContent = message;
    box.hidden = !message;
  }

  async function getCart() {
    const response = await fetch(root + 'cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Warenkorb nicht lesbar');
    return response.json();
  }

  async function postCart(endpoint, data) {
    const response = await fetch(root + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(await response.text());
    }

    return response.json();
  }

  async function syncServiceFee() {
    if (processing) return;

    processing = true;
    ready = false;
    setCheckoutDisabled(true);
    showError('');

    let reloadNeeded = false;

    try {
      const cart = await getCart();

      const fee = cart.items.find(
        item => item.variant_id === FEE_VARIANT_ID
      );

      const hasProducts = cart.items.some(
        item => item.variant_id !== FEE_VARIANT_ID
      );

      // Normale Produkte vorhanden, aber Gebühr fehlt
      if (hasProducts && !fee) {
        await postCart('cart/add.js', {
          items: [{
            id: FEE_VARIANT_ID,
            quantity: 1
          }]
        });

        reloadNeeded = true;
      }

      // Gebühr vorhanden, aber falsche Menge
      else if (hasProducts && fee.quantity !== 1) {
        await postCart('cart/change.js', {
          id: fee.key,
          quantity: 1
        });

        reloadNeeded = true;
      }

      // Keine normalen Produkte mehr: Gebühr entfernen
      else if (!hasProducts && fee) {
        await postCart('cart/change.js', {
          id: fee.key,
          quantity: 0
        });

        reloadNeeded = true;
      }

      if (reloadNeeded) {
        window.location.reload();
        return;
      }

      ready = hasProducts;
    } catch (error) {
      console.error('[Servicegebühr]', error);

      showError(
        'Die Servicegebühr konnte nicht aktualisiert werden. ' +
        'Bitte lade den Warenkorb erneut.'
      );
    } finally {
      processing = false;

      if (!reloadNeeded) {
        setCheckoutDisabled(!ready);
      }
    }
  }

  // Checkout nur bei synchronisiertem Warenkorb erlauben
  document.addEventListener('submit', function (event) {
    if (event.target.id === 'cart' && !ready) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Beim ersten Laden prüfen
  syncServiceFee();

  // Dawn: Nach Mengenänderungen / Entfernen erneut prüfen
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      syncServiceFee();
    });
  }
});
